<template>
  <div class="step" :class="{ 'step_active': active }">
    <div class="step__inner">
      <h3 class="step__title">Информация о событии, имеющем признаки страхового случая</h3>
      <DateInput :required="true" @setError="errors.date = $event" name="event-date" text="Дата наступления события" :range="false" v-model="form.event.date" />
      <SelInput :required="true" text="Тип риска" name="event-risktype" :options="eventrisktypes" v-model="form.event.risktype" />
      <SelInput :required="true" text="Страховое событие" name="event-type" :options="eventtypes" v-model="form.event.type" />
      <TextInput v-if="lostSumCondition" :required="true" v-model="form.event.lostsum" text="Сумма" :name="`event-lostsum`" @setError="errors.lostsum = $event" />
      <SelInput v-if="form.event.risktype == 'Жизнь/Здоровье'" :required="true" text="Причина страхового события" name="event-reason" :options="eventreasons" v-model="form.event.reason" />
      <template v-if="propertyAddressCondition">
        <div class="step__addressline">
          <TextInput :forceError="(form.event.propertyaddress.address && !addressIsCorrect) ? 'Укажите полный адрес' : ''" class="step__addressline-main" :required="true" :alignRight="true" v-model="form.event.propertyaddress.address" text="Адрес нахождения имущества" :name="`event-propertyaddress-address`" :optionsFunction="onlyHomeSuggest" :blurcondition="houseIsFilled" @setError="errors.propertyaddress = $event" :selectonly="true" :hideErrorWhenEmpty="true" />
          <TextInput v-show="!form.event.propertyaddress.noflat && !propertyAddressIsAutoCondition" class="step__addressline-flat" :required="true" :alignRight="true" v-model="form.event.propertyaddress.flat" :forceError="(form.event.propertyaddress.address && !addressIsCorrect) ? 'Укажите полный адрес' : ''" text="Кв." name="event-propertyaddress-flat" />
        </div>
        <CheckBox v-if="!propertyAddressIsAutoCondition" name="event-propertyaddress-noflat" v-model="form.event.propertyaddress.noflat">Частный дом</CheckBox>
      </template>
      <TextAreaInput :required="descriptionIsRequired" :maxlength="1000" :validation="(v) => (v.length > 1000) ? 'Не более 1000 символов' : ''" @setError="errors.description = $event" v-model="form.event.description" text="Описание обстоятельств наступления события:" name="event-description" />
      <Btn class="step__next" :disabled="!filled" @click.stop.prevent="$store.commit('nextStep')">Далее</Btn>
    </div>
  </div>
</template>

<script>
import Btn from '../Btn.vue';
import DateInput from '../inputs/DateInput.vue';
import SelInput from '../inputs/SelInput.vue';
import TextInput from '../inputs/TextInput.vue'
import TextAreaInput from '../inputs/TextAreaInput.vue';
import CheckBox from '../inputs/CheckBox.vue';
import { mapState } from 'vuex';
import dadataSuggest from '../../mixins/dadataSuggest';
import { mapGetters } from 'vuex/dist/vuex.cjs.js';

export default {
  components: { DateInput, SelInput, TextAreaInput, Btn, TextInput, CheckBox },
  data: () => ({
    dadataVariants: [],
    errors: {},
    eventrisktypes: ['', 'Жизнь/Здоровье', 'Инвестиционное/накопительное страхование жизни', 'Авто', 'Недвижимость', 'Личное имущество'],
  }),
  mixins: [dadataSuggest],
  props: {
    active: { type: Boolean }
  },
  methods: {
    async onlyHomeSuggest(q) {
      this.dadataVariants = await this.dadataSuggest(q, {
        settings: {
          query: q,
          count: 5,
          locations: [{ "country": "Россия" }],
          to_bound: { "value": "house" }
        },
        refresh: false,
        filterFunction: el => el.data && (el.data.city_kladr_id || el.data.settlement_kladr_id) && (!el.data.house || el.data.house_kladr_id) && !el.data.flat
      })
      return this.dadataVariants
    },
  },
  computed: {
    ...mapState(['form']),
    ...mapGetters(['propertyAddressCondition', 'propertyAddressIsAutoCondition']),
    houseIsFilled() {
      if (!this.dadataVariants.includes(this.form.event.propertyaddress.address))
        return false
      else {
        let option = this.fullDadataSuggest.find(el => el.value == this.form.event.propertyaddress.address)
        if (!option || !option.data.house || !option.data.house_kladr_id)
          return false
        return true
      }
    },
    addressIsCorrect() {
      if (!this.houseIsFilled)
        return false
      if (!this.form.event.propertyaddress.noflat && !this.form.event.propertyaddress.flat)
        return false
      return true
    },

    lostSumCondition() {
      if (this.form.event.type == 'Утрата денежных средств')
        return true
      return false
    },
    descriptionIsRequired() {
      return this.form.event.risktype != 'Инвестиционное/накопительное страхование жизни'
    },
    eventtypes() {
      switch (this.form.event.risktype) {
        case 'Жизнь/Здоровье':
          return ['', 'Смерть', 'Инвалидность I группы', 'Инвалидность II группы ', 'Инвалидность III группы ', 'Временная нетрудоспособность', 'Потеря работы/Снижение ЗП', 'Травма', 'Критическое заболевание']
        case 'Инвестиционное/накопительное страхование жизни':
          return ['', 'Дожитие', 'Смерть', 'Купон']
        case 'Авто':
          return ['', 'Полная гибель', 'Хищение деталей автомобиля', 'Поломка', 'Повреждения шин или дисков', 'Ущерб', 'Угон', 'Пожар', 'Противоправные действия']
        case 'Недвижимость':
          return ['', 'Залив', 'Пожар', 'Взрыв', 'Стихийное бедствие', 'Противоправные действия', 'Повреждение имущества соседей', 'Титул (утрата собственности)', 'Досрочное прекращение аренды', 'Удар молнии', 'Механические повреждения', 'Иное']
        case 'Личное имущество':
          return ['', 'Утрата банковской карты', 'Утрата денежных средств', 'Утеря ключей/документов/имущества', 'Поломка имущества', 'Повреждение имущества при доставке', 'Иное']
        default:
          return ['']
      }
    },
    eventreasons() {
      switch (this.form.event.type) {
        case 'Потеря работы/Снижение ЗП':
          return ['', 'Сокращение', 'Ликвидация', 'По соглашению сторон', 'Иное']
        case 'Критическое заболевание':
          return ['', 'Заболевание']
        default:
          return ['', 'Травма', 'Несчастный случай', 'Болезнь']
      }
    },
    filled() {
      for (let key in this.errors)
        if (this.errors[key])
          return false

      let required = ['date', 'type']
      if (this.descriptionIsRequired)
        required.push('description')
      if (this.propertyAddressCondition) {
        let localRequred = ['address']
        if (!this.form.event.propertyaddress.noflat)
          localRequred.push('flat')
        for (let key of localRequred)
          if (!this.form.event.propertyaddress[key])
            return false
        if (!this.addressIsCorrect)
          return false
      }
      if (this.lostSumCondition)
        required.push('lostsum')
      if (this.form.event.risktype == 'Жизнь/Здоровье')
        required.push('reason')

      for (let key of required) {
        let v = this.form.event
        let parsed
        while (key) {
          let k = key.match(/[^.]*/)[0]
          key = key.replace(k, '').replace(/^\./, '')
          if (k || (key === 0)) {
            v = v[k]
            parsed = true
          }
        }
        if (!parsed || !v)
          return false
      }
      return true
    },
  },
  watch: {
    propertyAddressIsAutoCondition(v) {
      if (v) {
        this.form.event.propertyaddress.flat = ''
        this.form.event.propertyaddress.noflat = true
      }
    },
    'form.event.propertyaddress.noflat': function (v) {
      if (!v)
        this.form.event.propertyaddress.flat = ''
    }

  }
}
</script>

<style lang="sass">
.step5__addbutton
  width: 585px
  max-width: 100%
  margin-bottom: 40px
  @include for-mob
    .addbtn__text
      text-align: left
</style>